/* eslint-disable functional/immutable-data */

import { useEffect, useState } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Integrates UsableNet, our accessibility partner, with our web app.
 *
 * @see {@link https://drive.google.com/file/d/17NdCq73PH_IggrIFHcI5SA9688m4-y50/view}
 * @see {@link https://drive.google.com/file/d/1egYpajjkAB43gozqSFV3O9RZqzWT7xqS/view}
 * @see {@link https://www.figma.com/design/yVkGHKQqxIgvDztsay7Lnd/UsableNet-Integration?node-id=1-3642&t=6LqxCrHsPy4ZTaXS-0}
 */
export const useUsableNet = () => {
  const isEnabled = useFeatureFlag('cels-3985-usable-net-enabled');
  const [isUsableNetReady, setIsUsableNetReady] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (!isEnabled) {
      setIsUsableNetReady(false);

      return;
    }

    // ─── Loading Script ──────────────────────────────────────────

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.dataset.rapid = 'true';
    script.addEventListener('load', () => {
      const usableNetWindow = window as unknown as UsableNetWindow;

      if (usableNetWindow.enableUsableNetAssistive) {
        setIsUsableNetReady(true);
      }
    });

    document.head.insertBefore(script, document.head.firstChild);
  }, [isEnabled]);

  return { isUsableNetReady };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SCRIPT_ID = 'usntA42start';
const SCRIPT_SRC =
  'https://a42cdn.usablenet.com/a42/sweetgreen/default/prod/cs-text-start';

// ─── Types ───────────────────────────────────────────────────────────────────

type UsableNetWindow = {
  enableUsableNetAssistive?: () => void;
};
